import getUniqueNumber from './utils/uniqueId'

export const SITE_NAME = 'Closr'

export const PERMISSIONS = {
  CAN_VIEW_PROPERTIES: 'can-view-properties',
  CAN_MANAGE_PROPERTIES: 'can-manage-properties',
  CAN_VIEW_EXCLUSIVE_UNITS: 'can-view-exclusive-units',
  CAN_MANAGE_EXCLUSIVE_UNITS: 'can-manage-exclusive-units',
  CAN_MANAGE_SALES_OFFER_TEMPLATES: 'can-manage-sales-offer-templates',
  CAN_VIEW_DICTIONARIES: 'can-view-dictionaries',
  CAN_MANAGE_DICTIONARIES: 'can-manage-dictionaries',
  CAN_MANAGE_ROLES: 'can-manage-roles',
  CAN_MANAGE_USERS: 'can-manage-users',
  CAN_VIEW_INTERNAL_PROJECTS: 'can-view-internal-projects',
  CAN_MANAGE_INTERNAL_PROJECTS: 'can-manage-internal-projects',
}

export const ROLES = {
  ADMIN: 'super_admin',
  CMS_USER: 'cms_user',
}

export const ENVS = {
  DEV: 'dev',
  STAGING: 'staging',
  PROD: 'prod',
}

export const DEFAULT_DEBOUNCE_INPUT_TIME = 500

export enum DICTIONARIES {
  SALE_STATUS = 'sale_status',
  PROPERTY_TYPE = 'property_type',
  PROPERTY_SUBTYPE = 'property_subtype',
  DEVELOPER_NAMES = 'developer_names',
  LOCATION = 'location',
  PROPERTY_AMENITY = 'property_amenity',
  EXCLUSIVE_UNIT_BEDROOM_TYPES = 'exclusive_unit_bedroom_types',
  EXCLUSIVE_UNIT_OPTIONAL_ROOM_TYPES = 'exclusive_unit_optional_room_types',
  EXCLUSIVE_UNIT_STATUSES = 'exclusive_unit_statuses',
  EXCLUSIVE_UNIT_TYPES = 'exclusive_unit_types',
  PROPERTIES = 'properties',
  FINANCE_DEVELOPERS = 'finance_developers',
  IMAGE_TYPES = 'image_types',
  EMIRATE_NAMES = 'emirate_names',
  LANGUAGES = 'languages',
  COUNTRIES = 'countries',
  TAGS = 'tags',
  FURNISHED_TYPES = 'furnished_types',
  DIRECTION_TYPES = 'exclusive_unit_direction_types',
  MARKETING_MATERIAL_CATEGORIES = 'marketing_material_categories',
  USER_TOURS = 'user_tours',
}

// The catalogue numbers internal (custom and community) projects from here; it treats them as
// internal whatever their is_internal flag says.
export const INTERNAL_PROJECT_START_ID = 900000

// A project's kind of exclusive deal; the catalogue API sends the number.
export enum EXCLUSIVE_TYPES {
  NONE = 0,
  EXCLUSIVE = 1,
  EXCLUSIVE_FAST_PAY = 2,
}

export const PROPERTIES_SALE_STATUSES = {
  ANNOUNCEMENT: 'announcement',
  LAUNCH: 'launch',
  ON_SALE: 'on_sale',
  PENDING: 'pending',
  PRE_SALE: 'presale(_e_o_i)',
  PRELIMINARY_INFO: 'preliminary_info',
  SOLD_OUT: 'sold_out',
}

export const PROPERTIES_ROOMS_MAP: { [key: string]: string } = {
  rooms_studio: 'Studio',
  rooms_1: '1 BR',
  rooms_2: '2 BR',
  rooms_3: '3 BR',
  rooms_4: '4 BR',
  rooms_5: '5 BR',
  rooms_6: '6 BR',
}

export enum USER_STATUS_CODES {
  INVITED = 'invited',
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export const TOKEN_KEY = 'token'

export const EXCLUSIVE_PLACEHOLDER_ID = getUniqueNumber()

export const NO_PAYMENT_PLAN_FILTER = 'none'

// Exclusive unit type ids that belong to each community sub-type, as the catalogue API matches a unit to its sub-project
export const EXCLUSIVE_UNIT_TYPE_IDS_BY_SUBTYPE = {
  villa: [3],
  townhouse: [2, 5],
  apartment: [1, 4],
}

export enum DLD_VALUES {
  BOOKING = 1,
  HANDOVER = 2,
}

export enum PAYMENT_PLAN_KEYS {
  ON_BOOKING = 'on_booking_percent',
  ON_HANDOVER = 'on_handover_percent',
}

export const DEFAULT_DLD_PERCENTAGE = '4'
export const NO_DRAG_CLASS = 'no-draggable'
export const DRAG_CLASS = 'draggable'

export enum IMAGE_TYPES_CODES {
  PROPERTY_EXTERNAL_IMAGE = 'property_external_image',
  PROPERTY_INTERNAL_IMAGE = 'property_internal_image',
  PROPERTY_MAIN_IMAGE = 'property_main_image',
}

export enum PROPERTY_FILE_TYPES {
  BROCHURE = 1,
}

export enum EXCLUSIVE_UNIT_STATUS_CODES {
  AVAILABLE = 'available',
  NOT_AVAILABLE = 'not_available',
  HOLD = 'hold',
}

export const PROPERTIES_SALE_STATUSES_COLOR_MAP = {
  [PROPERTIES_SALE_STATUSES.ANNOUNCEMENT]: 'bg-secondary-120',
  [PROPERTIES_SALE_STATUSES.PRE_SALE]: 'bg-success-100',
  [PROPERTIES_SALE_STATUSES.LAUNCH]: 'bg-alert-100',
  [PROPERTIES_SALE_STATUSES.ON_SALE]: 'bg-primary-100',
  [PROPERTIES_SALE_STATUSES.SOLD_OUT]: 'bg-error-100',
  [PROPERTIES_SALE_STATUSES.PRELIMINARY_INFO]: 'bg-primary-50',
}

export enum PROPERTIES_TAGS_CODES {
  PROPERTY_EXCLUSIVE = 'property-exclusive',
}

export const MEGABYTE = 1024 * 1024

export const MAX_FILE_SIZE = 50 * MEGABYTE

export const MAX_FILE_SIZE_MB = MAX_FILE_SIZE / MEGABYTE

export const MAX_FILE_LIMIT = 10

export const COMMUNITY_PROJECT = 'Community project'

export enum DATA_SOURCE_IDS {
  EXCLUSIVE = 'exclusive',
  STANDARD = 'standard',
}

/** Mirrors DeveloperContactSourceEnum on the catalogue API. */
export const DEVELOPER_CONTACT_SOURCE = {
  MANUAL: 'manual',
  PUBSUB: 'pubsub',
} as const

/** Mirrors SourceEnum on the catalogue API. */
export const DEVELOPER_SOURCE = {
  ALNAIR: 'alnair',
  PUBSUB: 'pubsub',
} as const

export enum TOURS_IDS {}

export enum TOURS_TYPES {
  NEW_FEATURE = 'new-feature',
  UPDATE = 'update',
  INIT_USER = 'init-user',
}
